import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { objectToSearchString, useQueryParams } from 'use-query-params';

import { useLocalStorage } from 'common/hooks';

import { purchasesQueryConfig } from './purchasesQueryConfig';

type Props = {
  rootRoute: string;
  defaultSubRoute: string;
  localStorageKey: string;
  children?: React.ReactNode;
};

const RootRedirector = ({ rootRoute, defaultSubRoute, localStorageKey, children }: Props) => {
  const [persistedSubroute, setPersistedSubroute] = useLocalStorage(localStorageKey, defaultSubRoute);
  const location = useLocation();

  const subPath = location.pathname.substring(rootRoute.length);

  const [query] = useQueryParams(purchasesQueryConfig);

  // Include only some of the known properties in stored subRoute
  const searchToPersist = objectToSearchString({ view: query.view, filters: query.filters });

  useEffect(() => {
    if (subPath) {
      setPersistedSubroute(`${subPath}${searchToPersist ? `?${searchToPersist}` : ''}`);
    }
  }, [setPersistedSubroute, subPath, searchToPersist]);

  if (!subPath) {
    // Try to restore the path from storage
    if (persistedSubroute && persistedSubroute.startsWith('/')) {
      return <Redirect to={`${rootRoute}${persistedSubroute}`} />;
    }

    // Otherwise redirect to the default path, keeping only known url query params
    const knownQueryString = objectToSearchString(query);
    const subRoute = `${defaultSubRoute}${knownQueryString ? `?${knownQueryString}` : ''}`;
    return <Redirect to={`${rootRoute}${subRoute}`} />;
  }

  return <>{children}</>;
};

export default RootRedirector;
